"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTheLoopsUserData = getTheLoopsUserData;
exports.refreshTheLoopsToken = refreshTheLoopsToken;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _axios = _interopRequireDefault(require("axios"));

// Constants
var JWE_TOKEN_API_ENDPOINT = '/theloops/generateWidgetJWEToken';
var JWE_TOKEN_API_ENDPOINT_CONTROL = '/integration/theloops/generateWidgetJWEToken';
/**
 * Gets user data for TheLoops integration
 * Handles both logged-in users and anonymous/guest users
 * @returns TheLoopsUserData object with userId and userEmail
 */

function getTheLoopsUserData() {
  return {
    userId: 'guest_user',
    userEmail: 'guest_user@example.com'
  };
}
/**
 * Refreshes the JWE token by calling the API
 * @param config - Configuration object containing widgetId and userId
 * @returns Promise that resolves to the new token or null if failed
 * @throws TheLoopsTokenError if the API call fails
 */


function refreshTheLoopsToken(_x) {
  return _refreshTheLoopsToken.apply(this, arguments);
}

function _refreshTheLoopsToken() {
  _refreshTheLoopsToken = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(config) {
    var _isFromControl,
        widgetId,
        userId,
        apiEndpoint,
        _data$data,
        _data$errorDesc,
        response,
        data,
        _args = arguments;

    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _isFromControl = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
            widgetId = config.widgetId, userId = config.userId;

            if (!(!widgetId || !userId)) {
              _context.next = 4;
              break;
            }

            throw new Error('Token generation failed: widgetId and userId are required');

          case 4:
            apiEndpoint = _isFromControl ? JWE_TOKEN_API_ENDPOINT_CONTROL : JWE_TOKEN_API_ENDPOINT;
            _context.prev = 5;
            _context.next = 8;
            return _axios.default.post(apiEndpoint, {
              widget_id: widgetId,
              user_id: userId
            });

          case 8:
            response = _context.sent;
            data = response.data;

            if (!(data.result && (_data$data = data.data) !== null && _data$data !== void 0 && _data$data.jwe_token)) {
              _context.next = 12;
              break;
            }

            return _context.abrupt("return", {
              token: data.data.jwe_token
            });

          case 12:
            throw new Error((_data$errorDesc = data.errorDesc) !== null && _data$errorDesc !== void 0 ? _data$errorDesc : 'Failed to refresh token');

          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](5);
            throw new Error(_context.t0.message);

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[5, 15]]);
  }));
  return _refreshTheLoopsToken.apply(this, arguments);
}